import {GET_USER, GET_USER_FAILURE, GET_USER_SUCCESS, UPDATE_STRIPE_ID, GET_ERROR_MESSAGE} from './constants';

const initialState = {
    user: {},
    limit: 10,
    errorMessage: '',
    loading: false
};

const appReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER: {
            return Object.assign({}, state, {user: {}, loading: true})
        }
        case GET_USER_SUCCESS: {
            return Object.assign({}, state, {user: action.data.data, loading: false})
        }
        case GET_USER_FAILURE: {
            return Object.assign({}, state, {user: {}, errorMessage: action.data.message, loading: false})
        }
        case UPDATE_STRIPE_ID: {
            const user = Object.assign({}, state.user, {stripe_customer_id: action.data})
            return Object.assign({}, state, {user})
        }
        case GET_ERROR_MESSAGE: {
            return Object.assign({}, state, {errorMessage: action.data.message })
        }
        default:
            return state;
    }
};

export default appReducer;
